import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import { useParams, Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

// Component for Vehicle Bill Form
const VehicleBillForm = () => {
  useAuthRedirect();
  const { vcode, basis } = useParams();

  const [billNo, setBillNo] = useState("");
  const [details, setVehicleDetails] = useState("");
  const [fetchPrice, setFetchPrice] = useState(null);
  const [hoursAmount, setHoursAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [balancePayable, setBalancePayable] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const navigate = useNavigate();
  const [data, setData] = useState({
    workingkm: 0,
    breakhour: 0,
    breakhour_amt: 0,
    totaldec_amt: 0,
  });

  const [spareData, setSpareData] = useState({
    totalSpareAmount: "0.00",
    totPercent: "0.00",
    spareAmount: "0.00",
  });

  // NEW: spares detail for the "Spares Details" table
  const [sparesTable, setSparesTable] = useState({
    items: [],
    baseTotal: 0,
    percentRate: 0,
    percentAmt: 0,
    totalWithPercent: 0,
  });

  const canEntry = hasPermission("Hire Bill Generation", "entry");

  const [formData, setFormData] = useState({
    billNumber: "",
    dateIssued: "",
    owner: "",
    panCard: "",
    vehicleName: "",
    user: user,
    otherCharges: "",
    particular: "",
    vehicleType: "",
    equipment: vcode,
    mailingAddress: "",
    vehicleBasis: basis,
    hours: "",
    ratePerHour: "",
    totalAmount: "0.00",
    otherCharges: "0",
    sparesAmount: "0.00",
    tdsDeductions: "0",
    maintenanceReason: "",
    maintenanceCharges: "",
    maintenance: 0,
    otherDeduction: 0,
  });

  useEffect(() => {
    fetchBillNo();
  }, []);

  const billNoo = formData.billNumber;
  const batanew = formData.otherCharges;

  // (kept) calculate endpoint — provides TDS% etc.
  useEffect(() => {
    if (branch && vcode && billNoo) {
      axios
        .get("https://rfs2.infraconsoft.net.in/api/calculate", {
          params: { branch, vcode, bill: billNoo, hoursAmount, fetchPrice, batanew },
        })
        .then((response) => {
          setSpareData(response.data || {});
        })
        .catch((error) => {
          console.error("Error fetching spare details:", error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch, vcode, billNoo, hoursAmount, fetchPrice, batanew]);

  const fetchBillNo = async () => {
    try {
      const { data } = await axios.get("https://rfs2.infraconsoft.net.in/api/billno");
      const billNo = data?.billNo ?? "1";
      setBillNo(billNo);
      setFormData((prev) => ({ ...prev, billNumber: billNo }));
    } catch (error) {
      console.error("Error fetching bill number:", error);
    }
  };

  useEffect(() => {
    let isMounted = true;

    const fetchVehicleDetails = async () => {
      if (!vcode) return;

      try {
        const res = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/bill_vehicleDetails?vehicle_code=${encodeURIComponent(vcode)}`
        );
        const raw = res?.data?.vehicleDetails;
        const d = Array.isArray(raw) ? (raw[0] ?? null) : (raw ?? null);

        if (!d) {
          if (isMounted) setVehicleDetails([]);
          return;
        }

        if (isMounted) {
          setVehicleDetails(Array.isArray(raw) ? raw : [d]);
          setFormData((prev) => ({
            ...prev,
            owner: d?.fld_vcompanyname ?? "",
            vehicleName: d?.fld_vname ?? "",
            panCard: d?.fld_panno ?? "",
            mailingAddress: d?.fld_panaddress ?? "",
            vehicleType: d?.fld_vtype ?? "",
          }));
        }
      } catch (err) {
        console.error("Error fetching vehicle details:", err);
      }
    };

    fetchVehicleDetails();
    return () => {
      isMounted = false;
    };
  }, [vcode]);

  useEffect(() => {
    axios
      .get(
        `https://rfs2.infraconsoft.net.in/api/bill_priceAmt?billNo=${formData.billNumber}&vcode=${vcode}`
      )
      .then((response) => {
        if (Array.isArray(response.data.fetchPrice) && response.data.fetchPrice.length > 0) {
          const fetchedHours = response.data.fetchPrice[0].fld_hoursamt;
          setFetchPrice(fetchedHours);
        } else {
          setFetchPrice(null);
        }
      })
      .catch((error) => {
        console.error("Error fetching vehicles:", error);
        setFetchPrice(null);
      });
  }, [formData.billNumber, vcode]);

  useEffect(() => {
    if (basis === "Month") {
      axios
        .get(`https://rfs2.infraconsoft.net.in/api/bill_vehicle_details_month`, {
          params: { branch, vcode, totalamt: grandTotal },
        })
        .then((response) => {
          setData(response.data);
        })
        .catch((error) => {
          console.error("Error fetching vehicle details:", error);
        });
    }
  }, [branch, vcode, basis, grandTotal]);

  useEffect(() => {
    if (!vcode) return;

    axios
      .get(`https://rfs2.infraconsoft.net.in/api/getHireVehicleRate`, {
        params: { vcode, fetchPrice },
      })
      .then((response) => {
        setHoursAmount(response.data.hoursAmount);
        setTotalAmount(response.data.totalamt);
      })
      .catch((error) => {
        console.error("Error fetching vehicle data:", error);
      });
  }, [vcode, fetchPrice]);

  // ===== fetch spares detail table for current bill =====
  useEffect(() => {
    if (!branch || !vcode || !billNoo) return;
    axios
      .get("https://rfs2.infraconsoft.net.in/api/spares_for_bill", {
        params: { branch, vcode, bill: billNoo },
      })
      .then((res) => {
        const p = res?.data || {};
        setSparesTable({
          items: p.items || [],
          baseTotal: Number(p.baseTotal || 0),
          percentRate: Number(p.percentRate || 0),
          percentAmt: Number(p.percentAmt || 0),
          totalWithPercent: Number(p.totalWithPercent || 0),
        });
      })
      .catch((err) => {
        console.error("Error fetching spares_for_bill:", err);
        setSparesTable({
          items: [],
          baseTotal: 0,
          percentRate: 0,
          percentAmt: 0,
          totalWithPercent: 0,
        });
      });
  }, [branch, vcode, billNoo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const total = Number(totalAmount) + Number(formData.otherCharges || 0);
    setGrandTotal(total);
  }, [totalAmount, formData.otherCharges]);

  // -------------------------------
  // NEW: Correct calculation order
  // -------------------------------
  // billingBase = what TDS should be calculated from
  //  - Month: data.totaldec_amt (e.g., 2442.90)
  //  - Others: grandTotal (e.g., 2500.00)
  const billingBase =
    basis === "Month" && data?.totaldec_amt != null
      ? Number(data.totaldec_amt)
      : Number(grandTotal || 0);

  const tdsPercent = Number(spareData?.tdsPercent || 0);
  const calculatedTDS = ((billingBase * tdsPercent) / 100).toFixed(2);

  // Grand Total (After TDS adding) must include spares (with %)
  const afterTDSPlusSpares = (
    billingBase +
    Number(sparesTable.totalWithPercent || 0) -
    Number(calculatedTDS || 0)
  ).toFixed(2);

  // Balance Payable should carry all amounts with spares
  useEffect(() => {
    const maintenanceValue = parseFloat(formData.maintenance) || 0;
    const otherDeductionValue = parseFloat(formData.otherDeduction) || 0;

    const newBalance = (
      Number(afterTDSPlusSpares) -
      maintenanceValue -
      otherDeductionValue
    ).toFixed(2);

    setBalancePayable(newBalance);
  }, [afterTDSPlusSpares, formData.maintenance, formData.otherDeduction]);
  // -------------------------------

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      branch,
      vcode: vcode,
      billNo: formData.billNumber,
      party: formData.owner,
      panCard: formData.panCard,
      vehicleName: formData.vehicleName,
      mailingAddress: formData.mailingAddress,
      vehicleType: formData.vehicleType,
      vehicleBasis: formData.vehicleBasis,
      equipment: formData.equipment,
      user: formData.user,
      particular: formData.particular,
      hours: fetchPrice,
      price: hoursAmount,
      totalAmt: totalAmount,
      metDetuction: formData.metDetuction,

      // total spares including percent (for inserting like PHP)
      spareAmt: sparesTable.totalWithPercent,
      spareTotAmt: sparesTable.totalWithPercent,

      totalKm: data?.workingkm,
      breakHr: data?.breakhour,
      breakAmt: data?.breakhour_amt,
      breaktot: data?.totaldec_amt,
      mainReason: formData.mainReason,
      mainCharge: formData.maintenance,
      bata: formData.otherCharges,
      bataTot: grandTotal,
      otherDecReason: formData.dedReason,
      otherDecAmt: formData.otherDeduction,
      tdsAmt: calculatedTDS,
      tdsPer: spareData?.tdsPercent,
      decReason: formData.metDetuction,
      totalAmt1: totalAmount,
      finalTotal: grandTotal,

      // send the corrected “after TDS + spares” total
      nAmt: afterTDSPlusSpares,

      balancePay: balancePayable,
    };

    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios.post("https://rfs2.infraconsoft.net.in/api/insert_bill", payload);

      Swal.fire({
        title: "Success!",
        text: "Hire Vehicle position data inserted successfully.",
        icon: "success",
        width: "500px",
        height: "40vh",
        draggable: true,
      }).then(() => {
        navigate(`/hire_vehicle_bill_report`);
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Submission failed. Please try again.");
    }
  };

  if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <div className="back-div">
            <h2 className="add-txt">Hire Bill Generation</h2>
            <Link to="/hire_vehicle_bill_report">
              <p className="back-button">
                <i className="fa-solid fa-backward"></i>Back
              </p>
            </Link>
          </div>
          <Time />
        </section>

        <div className="bill-container">
          <form onSubmit={handleSubmit} className="bill-form">
            <table className="bill-table">
              <tbody>
                <tr>
                  <td>Bill Number:</td>
                  <td>
                    <input
                      type="text"
                      name="billNo"
                      value={formData.billNumber}
                      onChange={handleChange}
                      readOnly
                    />
                  </td>
                  <td>Date:</td>
                  <td>
                    <input
                      type="date"
                      name="dateIssued"
                      value={
                        formData.dateIssued ||
                        new Date().toISOString().split("T")[0]
                      }
                      onChange={handleChange}
                      readOnly
                    />
                  </td>
                </tr>

                <tr>
                  <td>Name of the party:</td>
                  <td>
                    <input
                      type="text"
                      name="owner"
                      value={formData.owner}
                      onChange={handleChange}
                      readOnly
                    />
                  </td>
                  <td>PAN Card no:</td>
                  <td>
                    <input
                      type="text"
                      name="panCard"
                      value={formData.panCard}
                      onChange={handleChange}
                      readOnly
                    />
                  </td>
                </tr>

                <tr>
                  <td>Vehicle name:</td>
                  <td>
                    <input
                      type="text"
                      name="vehicleName"
                      value={formData.vehicleName}
                      onChange={handleChange}
                      readOnly
                    />
                  </td>
                  <td>Mailing Address:</td>
                  <td>
                    <input
                      type="text"
                      name="mailingAddress"
                      value={formData.mailingAddress}
                      onChange={handleChange}
                      readOnly
                    />
                  </td>
                </tr>

                <tr>
                  <td>Vehicle Type:</td>
                  <td>
                    <input
                      type="text"
                      name="vehicleType"
                      value={formData.vehicleType}
                      onChange={handleChange}
                      readOnly
                    />
                  </td>
                  <td>Vehicle Basis:</td>
                  <td>
                    <input
                      type="text"
                      name="vehicleBasis"
                      value={formData.vehicleBasis}
                      onChange={handleChange}
                      readOnly
                    />
                  </td>
                </tr>

                <tr>
                  <td>Equipment:</td>
                  <td>
                    <input
                      type="text"
                      name="equipment"
                      value={formData.equipment}
                      onChange={handleChange}
                      readOnly
                    />
                  </td>
                  <td>Prepared By:</td>
                  <td>
                    <input
                      type="text"
                      name="user"
                      value={formData.user}
                      onChange={handleChange}
                      readOnly
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <Link
              to={`/hire_veh_billdetails/${vcode}/${formData.billNumber}/${basis}`}
            >
              <h3>Add Vehicle</h3>
            </Link>
            <table className="bill-table">
              <thead>
                <tr>
                  <th>Bill Date</th>
                  <th>Particular</th>
                  <th>{basis}</th>
                  <th>Rate/Hr</th>
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {new Date().getDate()}/{new Date().getMonth() + 1}/
                    {new Date().getFullYear()}
                  </td>
                  <td>
                    <input
                      type="text"
                      name="particular"
                      value={formData.particular}
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    {fetchPrice !== null
                      ? basis === "Month"
                        ? `${
                            fetchPrice <= 1
                              ? fetchPrice + " Day"
                              : fetchPrice + " Days"
                          }`
                        : parseFloat(fetchPrice).toFixed(2)
                      : ""}
                    <input
                      type="hidden"
                      name="hours"
                      value={formData.fetchPrice || ""}
                    />
                  </td>
                  <td>
                    <div align="center">
                      {hoursAmount}
                      <input type="hidden" name="rate" value={hoursAmount} />
                    </div>
                  </td>
                  <td>
                    <div align="center" id="amount">
                      {(totalAmount || 0).toFixed(2)}
                      <input type="hidden" value={totalAmount || 0} />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <h3>Add Others (Bata)</h3>
            <table className="bill-table">
              <tbody>
                <tr>
                  <td>Total Amount:</td>
                  <td>{Number(totalAmount || 0).toFixed(2)}</td>
                </tr>
                <tr>
                  <td>Bata (Other Charges):</td>
                  <td>
                    <input
                      type="text"
                      name="otherCharges"
                      value={formData.otherCharges}
                      onChange={handleChange}
                      style={{ width: "80px" }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Grand Total:</strong>
                  </td>
                  <td>
                    <strong>{Number(grandTotal || 0).toFixed(2)}</strong>
                  </td>
                </tr>
              </tbody>
            </table>

            {basis === "Month" && (
              <table border="1">
                <thead>
                  <tr>
                    <th>Total km</th>
                    <th>Breaking Hours</th>
                    <th>Breaking Hours Amount</th>
                    <th>Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{data?.workingkm ?? "N/A"}</td>
                    <td>
                      {data?.breakhour != null
                        ? `${Math.floor(data.breakhour / 60)}h ${data.breakhour % 60}m`
                        : "N/A"}
                    </td>
                    <td>
                      {data?.breakhour_amt
                        ? Number(data.breakhour_amt).toFixed(2)
                        : "0.00"}
                    </td>
                    <td>
                      {data?.totaldec_amt
                        ? Number(data.totaldec_amt).toFixed(2)
                        : "0.00"}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}

            {/* ===== Spares Details (above deductions), only if items exist ===== */}
            {sparesTable.items.length > 0 && (
              <>
                <h3>Spares Details</h3>
                <table border="1">
                  <thead>
                    <tr>
                      <th>Material Code</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sparesTable.items.map((row, idx) => (
                      <tr key={idx}>
                        <td>{row.fld_spares}</td>
                        <td>{Number(row.amt).toFixed(2)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td>
                        <strong>Total Spares (Base)</strong>
                      </td>
                      <td>
                        <strong>{sparesTable.baseTotal.toFixed(2)}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>
                          Spares % ({sparesTable.percentRate.toFixed(2)}%)
                        </strong>
                      </td>
                      <td>
                        <strong>{sparesTable.percentAmt.toFixed(2)}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total Spares (with %)</strong>
                      </td>
                      <td>
                        <strong>
                          {sparesTable.totalWithPercent.toFixed(2)}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>
            )}

            <Link
              to={`/bill_sparesreport/${vcode}/${formData.billNumber}/${basis}`}
            >
              <h3>Add Spares</h3>
            </Link>
            <table border="1">
              <thead>
                <tr>
                  <th>Material Deductions</th>
                  <th>TDS Deductions %</th>
                  <th>TDS Amount</th>
                  <th>Grand Total (After TDS adding)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="text"
                      name="metDetuction"
                      value={formData.metDetuction}
                      onChange={handleChange}
                    />
                  </td>
                  <td>{spareData?.tdsPercent ?? "N/A"}</td>
                  <td>{calculatedTDS}</td>
                  <td>
                    {/* Includes spares (with %) and follows the new rule */}
                    <strong>{afterTDSPlusSpares}</strong>
                  </td>
                </tr>
              </tbody>
            </table>

            <h3>TDS </h3>
            <table className="bill-table">
              <tbody>
                <tr>
                  <td>
                    <strong>Maintenance Reason:</strong>
                  </td>
                  <td>
                    <textarea
                      name="mainReason"
                      value={formData.mainReason}
                      onChange={handleChange}
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Reason for Deduction:</strong>
                  </td>
                  <td>
                    <textarea
                      name="dedReason"
                      value={formData.dedReason}
                      onChange={handleChange}
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Maintenance Charges :</strong>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="maintenance"
                      onChange={handleChange}
                      value={formData.maintenance}
                      style={{ width: "100px" }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Other Deduction :</strong>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="otherDeduction"
                      onChange={handleChange}
                      value={formData.otherDeduction}
                      style={{ width: "100px" }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Balance Payable :</strong>
                  </td>
                  <td>
                    <strong>{balancePayable}</strong>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VehicleBillForm;
